/**
 * =============================================
 * ========= 国际化语言 english  en.js ==========
 * ====== 厦门科软信息科技有限公司 版权所有 =======
 * ==============================================
 */

const en = {
    /**
     * =============================================
     * ================ 公共部分 ====================
     * =============================================
     */


    /**
     * 列表操作按钮
     */
    "toolbar": {
        "btnAdd": "Add",
        "btnModify": "Modify",
        "btnUpdate": "Update",
        "btnEdit": "Edit",
        "btnDelete": "delete",
        "btnSoftDelete": "SoftDelete",
        "btnEnable": "Enable",
        "btnDisable": "Disable",
        "btnResetAppSecret": "ResetAppSecret",
        "btnResetEncodingAESKey": "ResetMessageSKey"
    },
    /**
     * 窗口操作按钮
     */
    "button": {
        "btnOk": "Ok",
        "btnSave": "Save",
        "btnCancel": "Cancel",
        "btnEdit": "Edit",
        "btnClose": "Close"
    },

    /**
     * 提示消息
     */
    "message": {
        "editAlertTips": "Please select a piece of data to edit.",
        "alertTips1": "Please select the data to operate first.",
        "successTips": "Congratulations! Operation succeeded!",
        "deleteTips": "Are you sure to delete the selected data item?",
        "selectDataTips": "Please select a piece of data to reset."
    },

    /**
     * =============================================
     * ================ 各模块 ====================
     * =============================================
     */

    "login": {
        "inputAccount": "Account",
        "inputPassword": "Password",
        "inputVcode": "Verification Code",
        "btnLoginText": "Login",
        "btnLoginIngText": "Loging...",
        "txtReg": "No Account?",
        "regLink": "Click Register",
        "txtLogin": "Have Account？",
        "loginLink": "Login",
        "ruleAccount": "Please enter login Account!",
        "rulePassword": "Please enter your Account password, which is not less than 6 digits!",
        "ruleVcodeTip": "Please enter the verification code",
        "ruleVcodeLengTip": "Length 4 characters"
    },

    "dashboard": {
        "serverInfo": "server information",
        "serverName": "server name",
        "operatingSystem": "operating system",
        "serverIP": "server IP",
        "numberofCPUs": "CPU "
    },
    /**
     * 默认应用管理
     */
    "app": {
        "systemName": "SAAS",
        "companyName": "XMTECH",
        "icpCode": "ICP:2021017202",
        "copyRight": "Copyright © 2021-2023 xmtechsoft.com",
    },
}

export default en